// extracted by mini-css-extract-plugin
module.exports = {"navbar":"navigation-module--navbar--10Yrn","navlink":"navigation-module--navlink--1RTOl"};